import { render, staticRenderFns } from "./sale-portal.vue?vue&type=template&id=63e4cea2&scoped=true"
import script from "./sale-portal.vue?vue&type=script&lang=js"
export * from "./sale-portal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e4cea2",
  null
  
)

export default component.exports